import React from 'react';

interface GlitchTextProps {
  text: string;
  className?: string;
}

export const GlitchText: React.FC<GlitchTextProps> = ({ text, className = '' }) => {
  return (
    <div className={`relative inline-block ${className}`}>
      <span className="relative z-10">{text}</span>
      <span
        className="absolute top-0 left-0 w-full h-full text-primary opacity-70 animate-glitch"
        aria-hidden="true"
        style={{ clipPath: 'polygon(0 0, 100% 0, 100% 45%, 0 45%)' }}
      >
        {text}
      </span>
      <span
        className="absolute top-0 left-0 w-full h-full text-secondary opacity-70 animate-glitch"
        aria-hidden="true"
        style={{ clipPath: 'polygon(0 55%, 100% 55%, 100% 100%, 0 100%)', animationDelay: '0.1s' }}
      >
        {text}
      </span>
    </div>
  );
};
